/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AccountDetailsDto {
  accountId: number;
  notes: string;
  jurisdiction: string;
  accountSubType: AccountDetailsDto.AccountSubTypeEnum;
  accountCreationDate: string;
  internalAccount: boolean;
}
export namespace AccountDetailsDto {
  export const AccountSubTypeEnum = {
    Btm: 'BTM',
    Exchange: 'EXCHANGE',
    Web3: 'WEB_3',
    Fund: 'FUND',
  } as const;
  export type AccountSubTypeEnum = (typeof AccountSubTypeEnum)[keyof typeof AccountSubTypeEnum];
}
